import {
  ForwardRefRenderFunction,
  MouseEventHandler,
  PointerEventHandler,
  forwardRef,
} from 'react';
import cn from 'classnames';
import { Size } from '@/types';
import { getMouseFallbackListener, getPointerListener } from '@/utils/pointerEvents';

interface ConfigurationHandleProps {
  size: Size;
  active: boolean;
  onPointerDown?: MouseEventHandler<HTMLButtonElement> | PointerEventHandler<HTMLButtonElement>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const ConfigurationMoveWithRef: ForwardRefRenderFunction<
  HTMLButtonElement,
  ConfigurationHandleProps
> = ({ size, active, onPointerDown, onClick }, ref) => (
  <foreignObject width={size.width} height={size.height}>
    <button
      ref={ref}
      type="button"
      className={cn('configuration-handles__move', active && 'configuration-handles__move--active')}
      onPointerDown={getPointerListener(onPointerDown)}
      onMouseDown={getMouseFallbackListener(onPointerDown)} /* fallback for Safari < 13 */
      onClick={onClick}
    ></button>
  </foreignObject>
);

export const ConfigurationMove = forwardRef(ConfigurationMoveWithRef);
